import * as React from 'react';

function SvgSiteCircleSolid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none">
        <circle cx={12} cy={12} r={12} fill="#000" />
        <path
          fill="#FFF"
          d="M7.5 10.93V16h1.85v-5.07L12 13.6l2.65-2.67V16h1.85v-5.07l2.64 2.67 1.36-1.38-4.93-4.97-3.57 3.6-3.57-3.6-4.93 4.97 1.36 1.38z"
        />
      </g>
    </svg>
  );
}

export default SvgSiteCircleSolid;
